import React from 'react';
import ProgramBlock from 'components/ProgramBlock';
import { IProps } from './types';
import _ from 'lodash';
import { EventProdList } from 'bff/models/promotion';
import { withRouter } from 'react-router-dom';
import commonService from 'utils/commonService';
import { AddFavoriteItem } from 'bff/models/member';

const InnerPageCSchemes: React.FC<IProps> = (props) => {
  return (
    <div className="schemes__inner-page-c-schemes">
      <div className="template-container">
        <div className="template-content">
          <div className="schemes__inner-page-c-schemes-items">
            {
              _.map(props.EVENT_PROD_LIST, (itemContent: EventProdList, index: number) => {
                // 新增我的收藏用 Model
                const addFavoriteItem: AddFavoriteItem = commonService.getAddFavoriteItem(itemContent.INS_TYPE_ID, itemContent.PROD_ID, itemContent.PLAN_ID);
                // 移除用的 SN 或 planId
                const removeId = commonService.getFavoriteItemSN(props.myFavoriteList || [], itemContent.INS_TYPE_ID, itemContent.PROD_ID, itemContent.PLAN_ID);
                return (
                  <ProgramBlock
                    key={index}
                    insTypeId={itemContent.INS_TYPE_ID}
                    content={itemContent}
                    active={commonService.matchFavorite(props.myFavoriteList, itemContent.INS_TYPE_ID, itemContent.PROD_ID, itemContent.PLAN_ID)}
                    onAddItem={() => props.onAddFavoriteItem(addFavoriteItem)}
                    onRemoveItem={() => props.onRemoveFavoriteItem(removeId)}
                    unloginAddItem={() => props.unloginAddItem(itemContent.INS_TYPE_ID, itemContent.PROD_ID, itemContent.PLAN_ID)}
                  />
                );
              })
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(InnerPageCSchemes);
